import { apiClient } from '../../../services/ApiClient';
import { type Action, ActionType } from '../../GlobalContextProvider/global-reducer';
import { type Settings } from '../types';
import { ApiEndpoints } from '../../../constants/api-constants';
import type React from 'react';

export const updateSettings = (settings: Settings, dispatch: React.Dispatch<Action>): void => {
  dispatch({ type: ActionType.UPDATE_SETTINGS, payload: settings });

  void apiClient.put(ApiEndpoints.settings, settings);
};
